import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const AreaChart = () => {
  const chartData = {
    draft: 10,
    inProgress: 20,
    readyForSubmission: 30,
    approved: 10,
    rejected: 30,
    aiPending: 20,
    aiCompleted: 50,
    aiFailed: 60,
  };

  const categories = [
    "Draft",
    "In Progress",
    "Ready for Submission",
    "Approved",
    "Rejected",
    "Pending",
    "Completed",
    "Failed",
  ];
  const data = Object.values(chartData);

  const options = {
    chart: {
      type: "area",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: categories,
      title: {
        text: "Task Status",
      },
    },
    yAxis: {
      title: {
        text: "Count",
      },
    },
    series: [
      {
        name: "Tasks",
        data: data,
      },
    ],
    plotOptions: {
      area: {
        fillOpacity: 0.5,
      },
    },
    credits: {
        enabled: false, // Disable the Highcharts.com watermark
      },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default AreaChart;
